<mat-menu #menu="matMenu" class="menu">
  <button mat-menu-item class="menu__item" routerLink="/minha-conta" routerLinkActive="active">
    <mat-icon class="menu__item__icon">manage_accounts</mat-icon>
    <span class="menu__item__text">Minha conta</span>
  </button>

  <mat-divider></mat-divider>

  <button mat-menu-item class="menu__item">
    <mat-icon>info</mat-icon>
    <span>Sobre</span>
  </button>

  <mat-divider></mat-divider>

  <button mat-menu-item class="menu__item" routerLink="/logout" routerLinkActive="active">
    <mat-icon>exit_to_app</mat-icon>
    <span>Fazer logout</span>
  </button>
</mat-menu>